var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"w-full h-full"},[(_vm.loggedIn)?_c('BaseSpinner',{staticClass:"z-90",attrs:{"overlay":"fixed","overlay-color":"white"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }